
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { I18nMixin } from '../../mixins';
import { IHomepageHomeServeBlockDefaultI18n, IHomepageHomeServeBlockOverrideI18n } from './types';

@Component
export default class HomeServeBlock extends Mixins(I18nMixin) {
  get cardColor() {
    return {
      lighter: '#000',
      light: '#f4f5f6',
      dark: '#edeeef',
      darker: '#343a40',
    };
  }

  public defaultI18n!: IHomepageHomeServeBlockDefaultI18n;

  @Prop()
  public overrideI18n!: IHomepageHomeServeBlockOverrideI18n;

  created() {
    this.defaultI18n = {
      block_simple: this.$t('components_plugin.homepage.homeserve_block.block_simple'),
      block_simple_desc: this.$t('components_plugin.homepage.homeserve_block.block_simple_desc'),
      block_pro: this.$t('components_plugin.homepage.homeserve_block.block_pro'),
      block_pro_desc: this.$t('components_plugin.homepage.homeserve_block.block_pro_desc'),
    };
  }
}
